import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './index.module.css';

import { T_SHIRT_SIZE_DEFAULT, T_SHIRT_SIZES } from '../../config';

const Heading = ({ center, children, size, type }) => {
  const Element = type;
  const wrapperClasses = classnames(
    styles.heading,
    styles[`heading${size}`],
    {
      [styles.headingCenter]: center,
    }
  );

  return (
    <Element className={wrapperClasses}>{children}</Element>
  );
}

Heading.propTypes = {
  center: PropTypes.bool,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(T_SHIRT_SIZES),
  type: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};

Heading.defaultProps = {
  center: false,
  size: T_SHIRT_SIZE_DEFAULT,
  type: 'h1',
};

export default Heading;
